import { env } from '@/lib/env';
import { useIsOrgAdmin } from '@/features/identity';
import { useWorkspaceStanding } from '@/features/workspaces';
import type { NavViewer } from '../navigation';

/**
 * Who the navigation is being drawn for, in this workspace.
 *
 * One reading for the sidebar and for a grouped entry's tab strip (spec 224), so a
 * tab can never be offered on a different rule from the entry that holds it.
 * Defaults to *not* owner while the reads load: a door that appears a moment late
 * is better than one that flashes in and out, and the service refuses regardless.
 */
export function useNavViewer(workspaceId: string): NavViewer {
  const standing = useWorkspaceStanding(workspaceId);
  const isOrgAdmin = useIsOrgAdmin();
  return {
    isWorkspaceOwner: standing.isOwner,
    isOrgAdmin,
    isWorkspaceMember: !standing.readOnly,
    showUnbuilt: env.VITE_SHOW_UNBUILT_SECTIONS,
  };
}
